import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import { ComponentType } from 'src/formcontrols/hoc/PopupModal/ModalEnum';
import * as ColorPalette from 'src/formcontrols/Themes/theme';
import './ModalHeader.css';

interface IProps {
    isComponentLoading: boolean,
    componentHeader: string,
    onPrintClicked?: () => any,
    onCloseClicked: () => void,
    componentType: ComponentType
}

const headerStyle = {
    backgroundColor: ColorPalette.colors.bg,
    'border': '0px',
    'color': ColorPalette.colors.text,
    'display': 'flex',
    'height': '48px',
    'width': '100%'
}

const ModalHeader = (props: IProps) => {
    return (
        <div className='modal-header' style={headerStyle}>
            <table className='inner'>
                <tbody>
                    <tr>
                        <td>
                            <span><b>{props.isComponentLoading === true ? '' : props.componentHeader}</b></span>
                        </td>
                        <td className='icons'>
                            {GetCloseIcon(props)}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
function GetCloseIcon(props: IProps) {
    return <CloseIcon onClick={props.onCloseClicked} />;
}

export default ModalHeader;